import React from "react";

export default ({allNumbersDrawing}) => {
    const rows = [];
    for (let index = 0; index < 8; index++) {
        const cols = [];
        for (let num = 1; num <= 10; num++) {
            const element = num + index * 10;
            cols.push(
                <td
                    key={element}
                    id={"lotto5-key" + element}
                    width="10%"
                >
                        <span
                            className={allNumbersDrawing?.includes(element) ? "active" : ""}>{element}</span>
                </td>
            );
        }
        rows.push(<tr key={index}>{cols}</tr>);
    }
    return rows;
}